'use client';

import type { HTMLAttributes } from 'react';
import styled from 'styled-components';

import type { SpacingType } from '@zoomit/primitives';
import { spacingHelper } from '@zoomit/primitives';

type ListProps = {
  spacing?: SpacingType;
};

const ListBase = styled.ul<ListProps>`
  list-style: none;
  padding: 0;
  margin-block: 0;
  ${({ spacing }) => spacing && spacingHelper(spacing)};
`;

type Props = HTMLAttributes<HTMLUListElement> & ListProps;

export const List = (props: Props) => {
  const { spacing, children, ...rest } = props;

  return (
    <ListBase spacing={spacing} {...rest}>
      {children}
    </ListBase>
  );
};
